import React from "react";
import { classNames } from "Utils/utils";
import { isCareWatchKpiActive } from "../utils/queueUtils";
import { KPI_ICONS } from "./CareWatchIcons";

const CareWatchKpiStrip = ({ kpis, filters, onSelect }) => {
  return (
    <div
      className="care-watch-kpis"
      style={{ "--cw-kpi-count": kpis.length }}
      data-count={kpis.length}
    >
      {kpis.map((kpi) => {
        const Icon = KPI_ICONS[kpi.icon];
        const active = isCareWatchKpiActive(kpi.key, filters);
        return (
          <button
            key={kpi.key}
            type="button"
            aria-pressed={active}
            aria-label={`${kpi.label}: ${kpi.value} ${kpi.unit}. ${kpi.caption}`}
            onClick={() => onSelect?.(kpi.key)}
            className={classNames("care-watch-kpi-tile", active && "is-active")}
            style={{ "--kpi-accent": kpi.accent }}
          >
            <span className="care-watch-kpi-rail" aria-hidden />
            <span className="care-watch-kpi-body">
              <span className="care-watch-kpi-top">
                <span className="care-watch-kpi-label">{kpi.label}</span>
                {Icon ? (
                  <span className="care-watch-kpi-icon">
                    <Icon size={15} stroke={kpi.accent} />
                  </span>
                ) : null}
              </span>
              <span className="care-watch-kpi-value-row">
                <span className="care-watch-kpi-value">{kpi.value}</span>
                <span className="care-watch-kpi-unit">{kpi.unit}</span>
              </span>
              <span className="care-watch-kpi-caption" title={kpi.caption}>
                {kpi.caption}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default CareWatchKpiStrip;
